import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Gallery.css';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const formatPrice = (price) =>
  new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    .format(price);

const Gallery = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeatured = async () => {
      try {
        const res = await axios.get(`${API_URL}/products`, { params: { limit: 50 } });
        const all = res.data.data?.products || res.data.products || [];
        const active = all
          .filter(
            (p) =>
              p.status !== 'inactive' &&
              p.status !== 'upcoming' &&
              (parseInt(p.stock ?? 0, 10) > 0 || p.fulfillment === 'dropshipping')
          )
          .sort((a, b) => {
            const aScore = a.stock > 0 ? 2 : (a.fulfillment === 'dropshipping' ? 1 : 0);
            const bScore = b.stock > 0 ? 2 : (b.fulfillment === 'dropshipping' ? 1 : 0);
            return bScore - aScore;
          })
          .slice(0, 6);
        setProducts(active);
      } catch {
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };
    fetchFeatured();
  }, []);

  const navigateToPage = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const categoryLabel = (cat) => {
    const map = {
      'productos-naturales': 'PRODUCTO NATURAL',
      'combos': 'COMBO',
      'ropa': 'ROPA',
      'ropa-hombre': 'ROPA',
      'ropa-mujer': 'ROPA',
    };
    return map[cat] || (cat || 'TIENDA').toUpperCase();
  };

  return (
    <section className="gallery gallery-banner" id="galeria">
      <div className="gallery-layout">
        {/* Columna título */}
        <div className="gallery-side">
          <h2 className="gallery-headline">Algunos de nuestros productos…</h2>
          <p className="gallery-subheadline">
            Piezas del holding que ya puedes explorar — naturales, cacao, prenda y más.
          </p>
          <button
            className="gallery-cta-main"
            onClick={() => navigateToPage('/tienda')}
          >
            Ver toda la tienda
          </button>
        </div>

        {/* Grid de productos reales */}
        <div className="gallery-grid gallery-grid-ia">
          {loading
            ? Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="gallery-card gallery-card-skeleton" />
              ))
            : products.map(product => {
                const image = (product.images && product.images[0]) || product.image || '/images/placeholders/placeholder-product.png';
                const isDropshipping = product.fulfillment === 'dropshipping';
                return (
                  <div
                    key={product.id}
                    className="gallery-card"
                    onClick={() => navigateToPage(`/producto/${product.id}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="gallery-card-image">
                      <img
                        src={image}
                        alt={product.name}
                        onError={(e) => { e.target.src = '/images/placeholders/placeholder-product.png'; }}
                      />
                      <div className="gallery-card-overlay">
                        <span className="gallery-card-tag">{categoryLabel(product.category)}</span>
                        <h3 className="gallery-card-title">{product.name}</h3>
                        <p className="gallery-card-price">
                          ${formatPrice(product.price)} COP
                          {isDropshipping && (
                            <span className="gallery-card-badge"> · Bajo pedido</span>
                          )}
                        </p>
                        <button
                          className="gallery-card-cta"
                          onClick={(e) => { e.stopPropagation(); navigateToPage(`/producto/${product.id}`); }}
                        >
                          Ver producto
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })
          }
        </div>
      </div>
    </section>
  );
};

export default Gallery;
